export default "/fonts/mydevicon.eot?cd9a9f6676411c86e40be476b71c1f81";